import { temporarilyNotSupport } from '../../utils'

// 判断支持版本
export const isVKSupport = /* @__PURE__ */ temporarilyNotSupport('isVKSupport')

// 视觉算法
export const createVKSession = /* @__PURE__ */ temporarilyNotSupport('createVKSession')
